
import { defineComponent, ref, watch } from 'vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { useProfile } from '@/composable/useProfile'
import { exportExcel } from '@/services/export-excel'
import { getCrossingTrackDelays } from '@/api/crossing-track-delay/getCrossingTrackDelays'
import { CrossingTrackDelay } from '@/types/crossing-track-delay'
import { format } from 'date-fns'

import AppFieldDate from '@/components/AppFieldDate.vue'

export default defineComponent({
  name: 'VehicleDefectsTable',

  components: {
    AppFieldDate,
  },

  setup() {
    const data = ref<CrossingTrackDelay[]>([])
    const loading = ref(false)

    const selectedDate = ref(format(new Date(), 'yyyy-MM-dd'))

    const fetchAll = async () => {
      loading.value = true
      const res = await getCrossingTrackDelays(selectedDate.value, 'G')
      loading.value = false
      data.value = res.data
        ? res.data.map((x, i) => ({
            ...x,
            index: i,
          }))
        : []
    }

    watch(selectedDate, fetchAll, {
      immediate: true,
    })

    const { can } = useProfile()
    const exporting = ref(false)

    const columns: QTable['columns'] = [
      {
        align: 'left',
        name: 'otn',
        label: 'OTN',
        field: 'otn',
        sortable: true,
      },
      {
        align: 'left',
        name: 'explanations',
        label: 'Förklaring',
        field: 'explanations',
        format: (x) => x.join('\n'),
        sortable: true,
      },
    ]

    async function onExport() {
      exporting.value = true

      const exportData = {
        name: 'Korsande tågväg',
        sheets: [
          {
            name: 'Korsande tågväg',
            data: data.value.map((item) => {
              return columns?.reduce<{ [name: string]: unknown }>(
                (acc, col) => {
                  const value =
                    typeof col.field === 'function'
                      ? col.field(item)
                      : item[col.name as keyof CrossingTrackDelay]

                  if (col.format) {
                    acc[col.label] = col.format(value, null)
                  } else {
                    acc[col.label] = value
                  }

                  return acc
                },
                {}
              )
            }),
          },
        ],
      }

      exportExcel(exportData)
      exporting.value = false
    }

    return {
      columns,
      loading,
      data,
      exporting,
      can,
      onExport,
      filterText: ref(''),
      fetchAll,
      selectedDate,
    }
  },
})
